import $ from 'jquery';

import {
    eventCheckoutAcceptTos,
    eventCheckoutHoverOfferButton,
    eventCheckoutHoverOrderButton,
    eventCheckoutClickOfferButton,
    eventCheckoutClickOrderButton,
    eventCheckoutViewSummary,
    eventCheckoutToggleNewsletter,
    eventCheckoutEnteredEmail,
} from '../matomo';

(globalThis as any).updateCheckout?.((globalThis as any).CART);

import financingTable from '../parts/financing-table';
const {cart} = await import('../yoocon-shop');
cart.on('update', () => {
    financingTable.$set({price: cart.total_gross()});
});

const $checkout_summary = $('#checkout-summary');
let checkout_summary_visible: boolean;
new IntersectionObserver(entries => entries.forEach(entry => {
    if(entry.isIntersecting && !checkout_summary_visible) {
        eventCheckoutViewSummary();
        checkout_summary_visible = true;
    }
}), {rootMargin: '-25% 0%'}).observe($checkout_summary[0]);

const $agb_check = $<HTMLInputElement>('#agb-check');
let agb_accepted: boolean;
$agb_check.on('change', () => {
    if(!agb_accepted && $agb_check[0].checked) {
        eventCheckoutAcceptTos();
        agb_accepted = true;
    }
});

const $order_button = $('#checkout-summary a.button');
let order_button_hovered: boolean;
$order_button.on('mouseenter', () => {
    if(!order_button_hovered) {
        eventCheckoutHoverOrderButton();
        order_button_hovered = true;
    }
}).on('click', () => {
    eventCheckoutClickOrderButton();
});

const $offer_button = $('#checkout-email-offer a.button');
let offer_button_hovered: boolean;
$offer_button.on('mouseenter', () => {
    if(!offer_button_hovered) {
        eventCheckoutHoverOfferButton();
        offer_button_hovered = true;
    }
}).on('click', () => {
    eventCheckoutClickOfferButton();
});

const $newsletter_checkbox = $<HTMLInputElement>('#newsletter-check');
$newsletter_checkbox.on('change', () => {
    eventCheckoutToggleNewsletter($newsletter_checkbox[0].checked);
});

(async () => {
    const {cart} = await import('../yoocon-shop');
    let email: string;
    cart.on('update', () => {
        const new_email = cart.email();
        if(!email && new_email)
            eventCheckoutEnteredEmail();
        email = new_email;
    });
})();
